import React from "react";

import * as auth from "@client/features/auth";

import * as router from "@client/router";

export const Logout = router.Logout.withHooks((props) => {
    React.useEffect(() => {
        void props.dispatch(auth.logout());
    }, []);
    return {};
})
    .withIndex(() => null)
    .withActions(() => [])
    .withOptions(() => ({
        title: "Logout",
    }));
